<template>
  <div class="sku-image-set-modal-wrapper">
    <keep-alive>
      <Modal v-model="modifyProductGoodsImgModal" v-if="renderModifyProductGoodsImgModal" title="变参 SKU 多语言独立图套配置面板"
        width="938px" :mask-closable="false">
        <!-- 顶部语言Tab -->
        <div class="sku-img-modal-tabs">
          <span v-for="tab in skuImgLangTabs" :key="tab.value"
            :class="['sku-img-tab', skuImgActiveTab === tab.value ? 'active' : '']"
            @click="skuImgActiveTab = tab.value; skuImgSpuFilterLang = tab.value">
            {{ tab.label }}
            <em v-if="skuImageSetList.filter(s => s.language === tab.value && (s.images || []).length > 0).length > 0"
              class="sku-img-tab-count">
              {{skuImageSetList.filter(s => s.language === tab.value).reduce((n, s) => n + (s.images || []).length, 0)
              }}
            </em>
          </span>
          <Button v-if="!isDisabled" icon="ios-color-wand-outline" type="primary" ghost size="small"
            class="sku-img-ai-btn" @click="openAiGenerateModal">AI生图</Button>
        </div>
        <!-- 当前操作语种提示 + 同步选项 -->
        <div class="sku-img-modal-sync-bar">
          <span>当前操作语种：<strong>{{ skuImgActiveLangLabel }}</strong></span>
          <Checkbox v-model="isSynchroAllSkcModel[skuImgActiveTab]" v-if="!isDisabled" style="margin-left:20px;">应用到相同
            model 的 SKU</Checkbox>
          <Checkbox v-model="isSynchroAllSkcColor[skuImgActiveTab]" v-if="!isDisabled" style="margin-left:10px;">应用到相同
            color 的 SKU</Checkbox>
        </div>
        <!-- 图套区域 -->
        <div class="sku-img-modal-suite" :loading="skuImageSetLoading">
          <!-- 图套标签行 -->
          <div class="sku-img-set-bar">
            <div class="sku-img-set-tags">
              <span v-for="imgSet in currentLangImageSets" :key="imgSet.productGoodsImageSetId"
                :class="['sku-img-set-tag', (currentActiveSet && currentActiveSet.productGoodsImageSetId === imgSet.productGoodsImageSetId) ? 'active' : '']"
                @click="switchImageSet(imgSet.productGoodsImageSetId)">
                {{ imgSet.setName }}
                <em v-if="imgSet.setType" class="sku-set-type-badge"
                  :style="{ background: getSetTypeBadgeColor(imgSet.setType) }">{{ getSetTypeLabel(imgSet.setType)
                  }}</em>
              </span>
            </div>
            <span class="sku-img-add-set-btn" @click="openAddSetModal" v-if="!isDisabled">+ 新增图套</span>
          </div>
          <!-- 当前图套图片列表 - 使用 draggable -->
          <div class="sku-img-set-content">
            <div v-if="currentSetImages.length == 0 && currentLangImageSets.length > 0"
              class="sku-img-no-set-tip">
              暂无图片
            </div>
            <draggable v-model="currentSetImages" :disabled="isDisabled" ghost-class="drag-ghost"
              chosen-class="drag-chosen" drag-class="drag-dragging" @start="onDragStart" @end="onDragEnd"
              class="draggable-container" :filter="'.no-drag'" :prevent-on-filter="false">
              <div v-for="(imgPath, index) in currentSetImages" :key="`set-img-${index}-${imgPath}`"
                style="width:100px;height:100px;flex-shrink:0;" class="product-upload-list"
                :class="{ 'drag-over': dragOverIndex === index }">
                <img :src="filenodeViewTargetUrl + imgPath">
                <div class="product-upload-list-cover" style="padding-top:24px;">
                  <Icon title="放大预览" type="ios-eye-outline" @click.native.prevent.stop="showViewer(index)" />
                  <template v-if="!isDisabled">
                    <Icon class="ml10" title="设为主图" type="ios-home-outline"
                      @click.native.stop="setSetPrimaryImg(imgPath)" />
                    <Icon class="mr10" title="删除" type="ios-trash-outline" @click.native.stop="removeSetImg(imgPath)" />
                 </template>
                </div>
              </div>
              <!-- 上传按钮 -->
              <dytUpload v-if="!isDisabled" file-name="files" ref="uploadProductGoodsImg" :headers="uploadFilesHeader"
                :show-upload-list="false" :max-size="uploadFilesMaxSize" :on-exceeded-size="uploadExceedSizeModal"
                :format="['jpg', 'png', 'gif']" :on-error="uploadFilesErrorModal" :on-success="uploadFilesSuccessModal"
                :on-format-error="handleFormatErrorModal" :action="uploadFilesUrl" multiple
                :before-upload="beforeUploadModal" type="drag" style="display: inline-block;width:100px;flex-shrink:0;margin-right: 4px;margin-top: 5px;" class="no-drag">
                <div style="width: 100px;height:100px;line-height: 100px;text-align:center;">
                  <div style="font-size:18px;color:#bbb;">+</div>
                  <!-- <div style="font-size:12px;color:#bbb;line-height:1.2;">上传网图</div> -->
                </div>
              </dytUpload>
            </draggable>

            <!-- 上传进度列表 -->
            <template v-for="(file, index) in uploadList">
              <div v-if="file.status !== 'finished'" class="product-upload-list" style="width:100px;height:100px;flex-shrink:0;"
                :key="index">
                <Progress v-if="file.showProgress" :percent="file.percentage"></Progress>
              </div>
            </template>

            <!-- 无图套时提示 -->
            <div v-if="currentLangImageSets.length === 0" class="sku-img-no-set-tip">
              暂无图套{{ isDisabled ? '!' : '，请点击「+ 新增图套」创建' }}
            </div>
          </div>
          <!-- 删除图套 / 编辑图套 -->
          <div class="sku-img-set-del-bar" v-if="currentActiveSet && !isDisabled">
            <span class="sku-img-edit-set-link" @click="openEditSetModal(currentActiveSet)">
              编辑图套名称/类型
            </span>
            <span class="sku-img-del-set-link" style="margin-left:14px;" @click="delImageSet(currentActiveSet)">
              删除图套 [{{ currentActiveSet.setName }}]
            </span>
          </div>
        </div>
        <!-- SPU公共图库 -->
        <div class="sku-img-modal-spu">
          <div class="sku-img-modal-spu-header">
            <span>从 SPU 公共图库快速添加图片</span>
            <div class="sku-img-spu-lang-filter">
              <span v-for="tab in skuImgLangTabs" :key="`filter-${tab.value}`"
                :class="['spu-filter-tag', skuImgSpuFilterLang === tab.value ? 'active' : '']"
                @click="skuImgSpuFilterLang = tab.value">{{ tab.shortLabel }}</span>
            </div>
          </div>
          <div class="sku-img-modal-spu-list">
            <template v-if="skuImgSpuImages.length > 0">
              <div v-for="(img, index) in skuImgSpuImages" :key="`spu-${index}-${img.path}`"
                style="width:90px;height:90px;" class="product-upload-list">
                <img :src="filenodeViewTargetUrl + img.path">
                <div class="product-upload-list-cover" style="padding-top:50px;">
                  <Button @click.stop="addImgToCurrentSet(img.path)" style="outline:none;box-shadow:none;" size="small"
                    type="text" v-if="!isDisabled">添加至SKU</Button>
                </div>
              </div>
            </template>
            <div v-else class="product-spu-list" style="width:90px;height:90px;">
              <Icon type="image" size="30" color="#d4d4d4"></Icon>
              <p>未添加图片</p>
            </div>
          </div>
        </div>
        <div slot="footer">
          <Button @click="confirModifyProductGoodsImg" type="primary" :loading="submitLoading" v-if="!isDisabled">保存并同步架构</Button>
          <Button @click="uploadModalCancel">取消</Button>
        </div>
      </Modal>
    </keep-alive>

    <!-- 新增/编辑图套弹框 -->
    <Modal v-model="skuAddSetModal" :title="skuAddSetIsEdit ? '编辑图套信息' : '新建语言专属图套'" width="420px" :footer-hide="true"
      @on-cancel="skuAddSetModal = false">
      <div class="sku-add-set-modal-body">
        <!-- 图套显示名称 -->
        <div class="sku-add-set-row">
          <label class="sku-add-set-label">图套显示名称</label>
          <Input v-model="skuAddSetName" placeholder="如：冬款质感主图" :maxlength="30" class="sku-add-set-input" />
          <div v-if="skuAddSetNameErr" class="sku-add-set-err">{{ skuAddSetNameErr }}</div>
        </div>
        <!-- 图套类型定义 -->
        <div class="sku-add-set-row">
          <label class="sku-add-set-label">图套类型定义</label>
          <div class="sku-add-set-type-list">
            <label v-for="opt in skuSetTypeOptions" :key="opt.value"
              :class="['sku-set-type-option', skuAddSetType === opt.value ? 'active' : '']"
              @click="skuAddSetType = opt.value">
              <span class="sku-set-type-radio">
                <span v-if="skuAddSetType === opt.value" class="sku-set-type-radio-dot"></span>
              </span>
              <span class="sku-set-type-badge-lg" :style="{ background: opt.color }">{{ opt.label }}</span>
            </label>
          </div>
        </div>
        <!-- 底部按钮 -->
        <div class="sku-add-set-footer">
          <Button @click="skuAddSetModal = false">取消</Button>
          <Button type="primary" style="margin-left:10px;" @click="confirmAddImageSet">{{ skuAddSetIsEdit ? '确认修改' :
            '确认创建'
          }}</Button>
        </div>
      </div>
    </Modal>

    <!-- AI生图弹窗（SKU维度） -->
    <aiGenerateModal v-model="aiGenerateModalVisible" dimension="sku" :product-id="productId"
      :product-goods-id="currentProductGoodsId" :multi-lang-image-data="multiLangImageData"
      :sku-image-set-list="skuImageSetList" :filenode-view-target-url="filenodeViewTargetUrl"
      @on-generate="handleAiGenerate" />
  </div>
</template>

<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import aiGenerateModal from './aiGenerateModal';
import { api as viewerApi } from "v-viewer";
import draggable from 'vuedraggable';

/**
 * @description SKU 图套配置弹框（从 editProduct.vue 拆分而来）
 * @author 前端开发
 * @date 2026-07-17
 * @功能说明
 *   1. 变参 SKU 多语言独立图套管理：新增/编辑/删除图套
 *   2. 图套内图片管理：上传网图、从 SPU 公共图库添加、设主图、删除
 *   3. 保存时支持"应用到相同 model / 相同 color 的 SKU"跨SKU联动同步
 *
 * @props说明
 *   - productId：商品ID，保存图套时提交用
 *   - skuData.sync：货品（SKU）数据，用于跨SKU联动读取/回填规格与图片
 *     （之所以对接 skuData 而不是 productGoodsList，是因为父组件 editProduct.vue
 *      现有的 watch 只支持 skuData → productGoodsList 单向同步，直接改 skuData
 *      即可复用该同步链路，无需父组件再新增反向 watch）
 *   - multiLangImageData.sync：SPU多语言图片数据（按语言分组），上传/添加图片时
 *     需要反向写入该分组，父组件已有 watch 自动同步到 productInfo.productImages
 *   - isDisabled：是否禁用编辑
 *
 * @对外暴露方法
 *   - editSkuImage(index)：由父组件通过 ref 调用，传入 productGoodsList 中的下标以打开弹框
 */
export default {
  name: 'skuImageSetModal',
  mixins: [Mixin],
  components: {
    aiGenerateModal,
    draggable
  },
  props: {
    /** 商品ID，保存图套接口需要 */
    productId: {
      type: String,
      default: ''
    },
    /** 货品（SKU）数据，.sync 双向绑定，跨SKU联动读取/回填 */
    skuData: {
      type: Array,
      default: () => []
    },
    /** SPU多语言图片数据，.sync 双向绑定 */
    multiLangImageData: {
      type: Array,
      default: () => []
    },
    /** 是否禁用编辑 */
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      submitLoading: false,
      /** 当前编辑的SKU在 skuData 中的下标 */
      editIndex: -1,
      // ========== 组件自身状态（原样迁移自 editProduct.vue） ==========
      /** 修改货品图片模态窗口显示隐藏标识 */
      modifyProductGoodsImgModal: false,
      /** 渲染修改货品图片模态窗口 */
      renderModifyProductGoodsImgModal: false,
      /** SKU图片弹框当前激活语言tab */
      skuImgActiveTab: 'common',
      /** SPU图库语言筛选 */
      skuImgSpuFilterLang: 'common',
      /** 应用到相同model的SKU（按语言区分） */
      isSynchroAllSkcModel: { common: false, en: false, fr: false, de: false, ru: false, nl: false },
      /** 应用到相同color的SKU（按语言区分） */
      isSynchroAllSkcColor: { common: false, en: false, fr: false, de: false, ru: false, nl: false },
      // 图套相关
      /** 当前SKU的图套列表（按语言+图套组织） */
      skuImageSetList: [],
      /** 图套加载中 */
      skuImageSetLoading: false,
      /** 当前各语言激活的图套id，{ common: id, en: id, ... } */
      skuActiveSetId: {},
      /** 新增/编辑图套弹框 */
      skuAddSetModal: false,
      /** true=编辑模式 false=新增模式 */
      skuAddSetIsEdit: false,
      /** 编辑模式下的目标图套对象 */
      skuAddSetEditTarget: null,
      /** 新增/编辑图套名称 */
      skuAddSetName: '',
      /** 新增/编辑图套类型（1网图 2非实拍自修图 3实拍自修图） */
      skuAddSetType: '1',
      /** 图套名称验证提示 */
      skuAddSetNameErr: '',
      // 图套类型选项
      skuSetTypeOptions: [
        { value: '1', label: '网图', color: '#f90' },
        { value: '2', label: '非实拍自修', color: '#19be6b' },
        { value: '3', label: '实拍自修', color: '#19be6b' }
      ],
      /** 上传文件列表 */
      uploadList: [],
      /** filenode根路径 */
      filenodeViewTargetUrl: this.$store.state.erpConfig.filenodeViewTargetUrl,
      /** 待上传的文件FormData列表 */
      uploadFilesList: [],
      /** 是否正在上传中（触发uploadFilesListHand） */
      isUploading: false,
      /** 上传loading状态 */
      uploadFilesLoading: false,
      /** 图片上传接口地址 */
      uploadFilesUrl: api.upload_files + '?basePath=/product',
      /** 上传文件大小上限（kb） */
      uploadFilesMaxSize: 10240,
      /** 一次最多选中20个图片上传 */
      uploadMaxLength: 20,
      /** 上传延迟定时器 */
      uploadFilesTime: null,
      /** 上传完成后的回调函数 */
      uploadFilesCalLback: () => { },
      /** AI生图弹窗显示状态 */
      aiGenerateModalVisible: false,
      // 拖拽相关状态
      dragOverIndex: -1,
      isDragging: false
    };
  },
  computed: {
    /** 当前正在编辑的 SKU 的 productGoodsId（供 AI生图弹窗使用） */
    currentProductGoodsId() {
      const cur = this.skuData[this.editIndex];
      return cur ? (cur.productGoodsId || '') : '';
    },
    /** 上传请求头（包含erp和dyt认证信息） */
    uploadFilesHeader() {
      return {
        ...this.$store.getters.erpRequestHeaders,
        ...this.$store.getters.dytRequestHeaders
      };
    },
    /** SKU图片弹框语言 tab 列表 */
    skuImgLangTabs() {
      return [
        { value: 'common', label: '通用', shortLabel: '通用' },
        { value: 'en', label: '英语 (EN)', shortLabel: 'EN' },
        { value: 'fr', label: '法语 (FR)', shortLabel: 'FR' },
        { value: 'de', label: '德语 (DE)', shortLabel: 'DE' },
        { value: 'ru', label: '俄语 (RU)', shortLabel: 'RU' },
        { value: 'nl', label: '荷兰语 (NL)', shortLabel: 'NL' }
      ];
    },
    /** 当前激活语言标签显示文本 */
    skuImgActiveLangLabel() {
      const tab = this.skuImgLangTabs.find(t => t.value === this.skuImgActiveTab);
      return tab ? tab.label : this.skuImgActiveTab;
    },
    /** SPU图库按语言筛选后的图片列表（直接读取 multiLangImageData prop，与 productInfo.productImages 数据同源） */
    skuImgSpuImages() {
      const allImages = [];
      (this.multiLangImageData || []).forEach(group => {
        (group.images || []).forEach(img => {
          allImages.push({ path: img.path, language: group.language });
        });
      });
      if (this.skuImgSpuFilterLang === 'all') return allImages;
      return allImages.filter(img => img.language === this.skuImgSpuFilterLang);
    },
    /** 当前语言下的图套列表 */
    currentLangImageSets() {
      return this.skuImageSetList.filter(s => s.language === this.skuImgActiveTab);
    },
    /** 当前语言激活的图套 id */
    currentActiveSetId() {
      return this.skuActiveSetId[this.skuImgActiveTab] || null;
    },
    /** 当前语言激活的图套对象 */
    currentActiveSet() {
      if (!this.currentActiveSetId) return this.currentLangImageSets[0] || null;
      return this.currentLangImageSets.find(s => s.productGoodsImageSetId === this.currentActiveSetId) || this.currentLangImageSets[0] || null;
    },
    /** 当前激活图套的图片路径数组 */
    currentSetImages: {
      get() {
        if (!this.currentActiveSet) return [];
        return this.currentActiveSet.images || [];
      },
      set(newVal) {
        if (this.currentActiveSet) {
          this.$set(this.currentActiveSet, 'images', newVal);
        }
      }
    },
    viewerImages() {
      if (this.$common.isEmpty(this.currentSetImages)) return [];
      return this.currentSetImages.map((img) => ({
        dataSource: this.filenodeViewTargetUrl + img,
      }));
    },
  },
  watch: {
    /** 监听上传状态，触发批量上传 */
    isUploading(val) {
      val && this.uploadFilesListHand();
    },
    /**
     * 监听弹框渲染状态，弹框刚渲染出来时把 dytUpload 内部的 fileList 关联到 uploadList，
     * 使上传进度条（Progress）能正常显示
     * 【修复】此 watch 为第一步迁移时遗漏，现补齐（原 editProduct.vue L1395-1404）
     */
    renderModifyProductGoodsImgModal(n) {
      if (n) {
        this.$nextTick(() => {
          const uploadRef = this.$refs.uploadProductGoodsImg;
          if (uploadRef && uploadRef.fileList) {
            this.uploadList = uploadRef.fileList;
          }
        });
      }
    }
  },
  methods: {
    onDragStart(evt) {
      this.isDragging = true;
      this.dragOverIndex = -1;
      // console.log('[拖拽开始] 从索引:', evt.oldIndex);
    },
    onDragEnd(evt) {
      this.isDragging = false;
      this.dragOverIndex = -1;
      // console.log('[拖拽结束] 到索引:', evt.newIndex);
    },
    /** 打开 AI 生图弹窗（SKU 维度） */
    openAiGenerateModal() {
      if (!this.currentProductGoodsId) {
        this.$Message.error('缺少 SKU 标识，请先保存 SKU');
        return;
      }
      this.aiGenerateModalVisible = true;
    },
    /**
     * AI 生图完成回调（占位）
     *
     * @param {Object} payload aiGenerateModal 组装的提交参数
     * @param {Object} result  接口返回结果（预期：{ images: [{ path, productImageId? }, ...] }）
     *
     * TODO: 接口就位后的真实实现（SKU 维度）：
     *   1. 从 result.images 中取出新生成的图片路径
     *   2. 定位到 payload.targetImageSetId 对应的图套（this.skuImageSetList 中），将新图片
     *      push 到该图套的 images 数组（当前存的是纯路径字符串）
     *   3. 若 payload.applySpecificationNames 非空（["Size"]/["Color"]/["Size","Color"]），
     *      需同步到其他相同 model/color 的 SKU（可复用 confirModifyProductGoodsImg 的同步算法）
     *   4. 若 payload.数组中的图片同时需写入 SPU 公共图库，可调用 pushImageToCommonGroup
     *
     * 备注：目前图套内的图片变更是"本地暂存"、等用户点"保存并同步架构"才提交；
     *   本接口若后端设计为直接落库，则还需并行更新该图套的 productGoodsImageSetId
     */
    handleAiGenerate(payload, result) {
      // eslint-disable-next-line no-console
      // console.log('[skuImageSetModal] AI生图 payload:', payload, 'result:', result);
    },
    /** 打开SKU图片编辑弹框（父组件通过 ref 调用，传入 skuData 中的下标） */
    editSkuImage(index) {
      const productGoodsId = this.skuData[index] && this.skuData[index].productGoodsId;
      if (!productGoodsId) {
        this.$Modal.confirm({
          title: '提示',
          content: '请先点击右上角“保存”按钮保存SKU后再操作',
          okText: '确定',
          cancelText: '取消',
          onOk: () => { }
        });
        return;
      }
      this.renderModifyProductGoodsImgModal = true;
      this.$nextTick(() => {
        this.modifyProductGoodsImgModal = true;
        this.skuImgActiveTab = 'common';
        this.skuImgSpuFilterLang = 'common';
        this.isSynchroAllSkcModel = { common: false, en: false, fr: false, de: false, ru: false, nl: false };
        this.isSynchroAllSkcColor = { common: false, en: false, fr: false, de: false, ru: false, nl: false };
        this.skuActiveSetId = {};
        this.skuImageSetList = [];
        // 加载图套列表
        this.loadImageSetList(productGoodsId);
      });
      this.editIndex = index;
    },
    /** 加载SKU图套列表 */
    loadImageSetList(productGoodsId) {
      this.skuImageSetLoading = true;
      this.axios.get(api.get_productGoodsImageSetList + productGoodsId).then(res => {
        if (res && res.data && res.data.code === 0) {
          this.skuImageSetList = (res.data.datas || []).map(item => {
            // 保留 images 为纯路径字符串数组（不改变现有数据结构，避免回归）；
            // 同时旁路构建 imageIdMap：path -> productGoodsImageId，供 AI 生图选图时反查 imageId 使用
            const rawImages = item.images || [];
            const imageIdMap = {};
            const images = rawImages.map(img => {
              if (typeof img === 'string') {
                return img;
              }
              if (img && img.path && img.productGoodsImageId !== undefined && img.productGoodsImageId !== null) {
                imageIdMap[img.path] = img.productGoodsImageId;
              }
              return img.path;
            });
            return {
              ...item,
              productGoodsImageSetId: String(item.productGoodsImageSetId || ''),
              images,
              imageIdMap
            };
          });
        } else {
          this.skuImageSetList = [];
        }
      }).catch(() => {
        this.skuImageSetList = [];
      }).finally(() => {
        this.skuImageSetLoading = false;
      });
    },
    /** 切换图套 */
    switchImageSet(setId) {
      this.$set(this.skuActiveSetId, this.skuImgActiveTab, setId);
      this.dragOverIndex = -1;
    },
    /** 打开新增图套弹框 */
    openAddSetModal() {
      this.skuAddSetIsEdit = false;
      this.skuAddSetEditTarget = null;
      this.skuAddSetName = '';
      this.skuAddSetType = '1';
      this.skuAddSetNameErr = '';
      this.skuAddSetModal = true;
    },
    /** 打开编辑图套弹框 */
    openEditSetModal(imgSet) {
      this.skuAddSetIsEdit = true;
      this.skuAddSetEditTarget = imgSet;
      this.skuAddSetName = imgSet.setName || '';
      this.skuAddSetType = String(imgSet.setType || '1');
      this.skuAddSetNameErr = '';
      this.skuAddSetModal = true;
    },
    /** 获取图套类型标签文字 */
    getSetTypeLabel(setType) {
      const map = { '1': '网图', '2': '非实拍自修', '3': '实拍自修' };
      return map[String(setType)] || String(setType);
    },
    /** 获取图套类型 badge 颜色 */
    getSetTypeBadgeColor(setType) {
      const map = { '1': '#f90', '2': '#19be6b', '3': '#19be6b' };
      return map[String(setType)] || '#999';
    },
    /** 确认新增/编辑图套 */
    confirmAddImageSet() {
      const setName = this.skuAddSetName.trim();
      if (!setName) {
        this.skuAddSetNameErr = '图套名称不能为空';
        return;
      }
      this.skuAddSetNameErr = '';
      // 同一语言下图套名称去重校验
      const currentLang = this.skuImgActiveTab;
      const excludeId = this.skuAddSetIsEdit && this.skuAddSetEditTarget
        ? this.skuAddSetEditTarget.productGoodsImageSetId
        : null;
      const duplicate = this.skuImageSetList.find(s => {
        return s.language === currentLang &&
          s.setName === setName &&
          (!excludeId || String(s.productGoodsImageSetId) !== String(excludeId));
      });
      if (duplicate) {
        this.$Message.warning(`图套名称已存在：${setName}`);
        return;
      }
      const productGoodsId = this.skuData[this.editIndex].productGoodsId;
      if (this.skuAddSetIsEdit && this.skuAddSetEditTarget) {
        // 编辑模式：调用 update 接口
        const payload = {
          productGoodsImageSetId: this.skuAddSetEditTarget.productGoodsImageSetId,
          productGoodsId,
          language: this.skuImgActiveTab,
          setName: setName,
          setType: this.skuAddSetType
        };
        this.axios.post(api.update_productGoodsImageSet, payload).then(res => {
          if (res && res.data && res.data.code === 0) {
            this.skuAddSetEditTarget.setName = payload.setName;
            this.skuAddSetEditTarget.setType = payload.setType;
            this.$Message.success('图套信息已更新');
          }
        });
      } else {
        // 新增模式：调用 add 接口
        const payload = {
          productGoodsId,
          language: this.skuImgActiveTab,
          setName: setName,
          setType: this.skuAddSetType
        };
        this.axios.post(api.add_productGoodsImageSet, payload).then(res => {
          if (res && res.data && res.data.code === 0) {
            const newSet = {
              productGoodsImageSetId: res.data.datas || String(Date.now()),
              setName: payload.setName,
              setType: payload.setType,
              language: payload.language,
              images: []
            };
            this.skuImageSetList.push(newSet);
            this.$set(this.skuActiveSetId, this.skuImgActiveTab, newSet.productGoodsImageSetId);
            this.$Message.success('新增图套成功');
          }
        });
      }
      this.skuAddSetModal = false;
    },
    /** 删除图套 */
    delImageSet(imgSet) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确认删除图套「${imgSet.setName}」吗？此操作不可撤销。`,
        onOk: () => {
          if (!imgSet.productGoodsImageSetId) return;
          const targetId = String(imgSet.productGoodsImageSetId);
          this.axios.post(api.del_productGoodsImageSet + targetId).then(res => {
            if (res && res.data && res.data.code === 0) {
              const idx = this.skuImageSetList.findIndex(s => String(s.productGoodsImageSetId) === targetId);
              if (idx !== -1) this.skuImageSetList.splice(idx, 1);
              // 若删除的是当前激活图套，重置到第一个
              if (String(this.skuActiveSetId[this.skuImgActiveTab]) === targetId) {
                const next = this.currentLangImageSets[0];
                this.$set(this.skuActiveSetId, this.skuImgActiveTab, next ? next.productGoodsImageSetId : null);
              }
              this.$Message.success('图套已删除');
            } else {
              this.$Message.error((res.data && res.data.message) || '删除图套失败');
            }
          });
        }
      });
    },
    /** 将图片加入当前图套（仅本地操作，不请求接口） */
    addImgToCurrentSet(path) {
      if (!this.currentActiveSet) {
        this.$Modal.confirm({
          title: '提示',
          content: '请先选择或创建图套',
          okText: '确定',
          cancelText: '取消',
          onOk: () => { }
        });
        return;
      }
      const set = this.currentActiveSet;
      if (!set.images) this.$set(set, 'images', []);
      if (!set.images.includes(path)) {
        set.images.push(path);
      }
    },
    /** 删除当前图套中的图片 */
    removeSetImg(imgPath) {
      if (!this.currentActiveSet) return;
      const set = this.currentActiveSet;
      const idx = (set.images || []).indexOf(imgPath);
      if (idx !== -1) set.images.splice(idx, 1);
    },
    /** 设置当前图套主图（置顶） */
    setSetPrimaryImg(imgPath) {
      if (!this.currentActiveSet) return;
      const set = this.currentActiveSet;
      const idx = (set.images || []).indexOf(imgPath);
      if (idx !== -1) set.images.splice(idx, 1);
      set.images.unshift(imgPath);
    },
    /** sku列表上传成功 */
    uploadFilesSuccessModal(response, file, fileList) {
      const path = file && file.response && file.response.datas ? file.response.datas[0] : '';
      if (this.$common.isEmpty(path)) {
        console.warn('[uploadFilesSuccessModal] 上传返回 path 为空', file);
        return;
      }
      // 加入当前激活图套
      this.addImgToCurrentSet(path);
      const setName = this.currentActiveSet ? this.currentActiveSet.setName : '';
      this.pushImageToCommonGroup(path, this.skuImgActiveTab, setName);
    },
    uploadExceedSizeModal() {
      this.$Message.error('文件大小超出限制，最大为10M');
    },
    uploadFilesErrorModal() {
      this.$Message.error('系统繁忙，请重新尝试');
    },
    /** sku列表上传失败 */
    handleFormatErrorModal() {
      this.$Message.error('文件格式有误');
    },
    beforeUploadModal(file) {
      let selectedFiles = this.$refs.uploadProductGoodsImg.$refs.input.files;
      let curFileIndex = -1;
      for (let i = 0; i < selectedFiles.length; i++) {
        if (selectedFiles[i] === file) {
          curFileIndex = i;
        }
      }
      if (curFileIndex === 0 && selectedFiles.length > this.uploadMaxLength) {
        this.$Message.error('文件数量超出限制，一次最多可上传20张');
        return false;
      } else if (selectedFiles.length > this.uploadMaxLength) {
        return false;
      }
      let newForm = new FormData();
      newForm.append('files', file);
      this.uploadFilesTime && clearTimeout(this.uploadFilesTime);
      this.uploadFilesList.push(newForm);
      this.uploadFilesTime = setTimeout(() => {
        this.isUploading = true;
        this.uploadFilesCalLback = (arr) => {
          arr.forEach((newres) => {
            const path = newres && newres.data && newres.data.datas ? newres.data.datas[0] : '';
            if (this.$common.isEmpty(path)) {
              console.warn('[beforeUploadModal] 上传返回 path 为空', newres);
              return;
            }
            // 加入当前激活的 SKU 图套
            this.addImgToCurrentSet(path);
            // 同步到 SPU 图库当前激活语言分组
            const setName = this.currentActiveSet ? this.currentActiveSet.setName : '';
            this.pushImageToCommonGroup(path, this.skuImgActiveTab, setName);
          });
          this.$nextTick(() => {
            this.uploadFilesCalLback = () => { };
          });
        };
      }, 300);
      return false;
    },
    // 按顺序上传
    uploadFilesListHand() {
      this.uploadFilesLoading = true;
      const awaitList = this.uploadFilesList.map(file => {
        return this.axios.post(`${this.uploadFilesUrl}&random=${(Math.random()).toString().substring(2)}`, file);
      });
      Promise.all(awaitList).then(arr => {
        this.uploadFilesCalLback(arr);
        this.uploadFilesList = [];
        this.isUploading = false;
        this.uploadFilesLoading = false;
      }).catch(() => {
        this.uploadFilesList = [];
        this.isUploading = false;
        this.uploadFilesLoading = false;
      });
    },
    /** 确认修改图片 */
    confirModifyProductGoodsImg() {
      const productGoodsId = this.skuData[this.editIndex].productGoodsId;
      // 构建 applySpecificationNames：勾选 model 传 "Size"，勾选 color 传 "Color"
      let applySpecificationNames = [];
      // 遍历当前 SKU 的所有图套，逐个调用 saveImages 接口
      let saveRequests = [];
      let graphicImages = [];
      let spuImages = [];
      let updateImages = {};
      this.multiLangImageData.forEach(item => {
        if (this.$common.isUndefined(updateImages[item.language])) {
          updateImages[item.language] = [];
        }
        (item.images || []).forEach(m => {
          if (m.addCommon) {
            updateImages[item.language].push(m.path);
          }
        });
      });
      this.skuImageSetList.forEach((imgSet, index) => {
        applySpecificationNames = [];
        graphicImages = [];
        spuImages = [];
        if (this.isSynchroAllSkcModel[imgSet.language]) applySpecificationNames.push('Size');
        if (this.isSynchroAllSkcColor[imgSet.language]) applySpecificationNames.push('Color');
        (imgSet.images || []).forEach(img => {
          graphicImages.push({ path: img });
          if (updateImages[imgSet.language] && updateImages[imgSet.language].includes(img)) {
            spuImages.push(img);
          }
        });
        saveRequests.push({
          productId: this.productId,
          productImages: spuImages,
          productGoodsId,
          imageSetId: imgSet.productGoodsImageSetId,
          language: imgSet.language,
          images: graphicImages,
          applySpecificationNames: applySpecificationNames
        });
      });
      this.submitLoading = true;
      this.axios.post(api.saveImagesBatch_productGoodsImageSet, saveRequests).then(res => {
        if (res.data.code !== 0) {
          this.$Message.warning('图套保存未成功，请刷新后确认');
          return;
        }
        this.$Message.success('图套保存成功');
        // 接口全部成功后再更新本地数据，使商品多属性列表图片列同步刷新
        const newImages = [];
        this.skuImageSetList.forEach(imgSet => {
          (imgSet.images || []).forEach(path => {
            newImages.push({ path, language: imgSet.language, setName: imgSet.setName });
          });
        });
        // 基于 skuData 的深拷贝进行计算，避免直接修改 prop
        const list = this.deepCopy(this.skuData);
        const currentItem = list[this.editIndex];
        const model = (currentItem.productGoodsSpecifications && currentItem.productGoodsSpecifications[1])
          ? currentItem.productGoodsSpecifications[1].value || ''
          : '';
        const color = (currentItem.productGoodsSpecifications && currentItem.productGoodsSpecifications[0])
          ? currentItem.productGoodsSpecifications[0].value || ''
          : '';
        const newImagesByLang = {};
        newImages.forEach(img => {
          if (!newImagesByLang[img.language]) newImagesByLang[img.language] = [];
          newImagesByLang[img.language].push(img);
        });
        list.forEach((k, i) => {
          if (i === this.editIndex) {
            k.productGoodsImages = this.deepCopy(newImages);
            return;
          }
          const kModel = (k.productGoodsSpecifications && k.productGoodsSpecifications[1])
            ? k.productGoodsSpecifications[1].value || ''
            : '';
          const kColor = (k.productGoodsSpecifications && k.productGoodsSpecifications[0])
            ? k.productGoodsSpecifications[0].value || ''
            : '';
          const syncedLanguages = Object.keys(newImagesByLang).filter(language => {
            const matchModel = this.isSynchroAllSkcModel[language] && model && kModel === model;
            const matchColor = this.isSynchroAllSkcColor[language] && color && kColor === color;
            return matchModel || matchColor;
          });
          if (syncedLanguages.length === 0) return;
          let updatedImages = this.deepCopy(k.productGoodsImages || []);
          syncedLanguages.forEach(language => {
            updatedImages = updatedImages.filter(img => img.language !== language);
            updatedImages.push(...this.deepCopy(newImagesByLang[language]));
          });
          k.productGoodsImages = updatedImages;
        });
        // 将计算结果整体 emit 给父组件，父组件现有 watch(skuData) 会自动同步到 productInfo.productGoodsList
        this.$emit('update:skuData', list);
        this.modifyProductGoodsImgModal = false;
      }).finally(() => {
        this.submitLoading = false;
      });
    },
    /** 上传图片模态框取消 */
    uploadModalCancel() {
      this.skuImageSetList = [];
      this.skuActiveSetId = {};
      this.modifyProductGoodsImgModal = false;
      this.isDragging = false;
      this.dragOverIndex = -1;
    },
    /**
     * 将图片信息插入 multiLangImageData 指定语言分组，并 emit 给父组件同步到 productInfo.productImages（SPU 公共图库）
     * 【改造】原实现直接 push/$set 修改 prop（this.multiLangImageData），违反单向数据流；
     * 现改为计算出新数组后通过 $emit('update:multiLangImageData', ...) 交由父组件更新
     */
    pushImageToCommonGroup(path, language = '', setName = '') {
      if (this.$common.isEmpty(path)) {
        console.warn('[pushImageToCommonGroup] path 为空，跳过同步');
        return;
      }
      if (this.$common.isEmpty(language)) {
        console.warn('[pushImageToCommonGroup] language 为空，跳过同步');
        return;
      }
      if (this.$common.isEmpty(setName)) {
        console.warn('[pushImageToCommonGroup] setName 为空，跳过同步');
        return;
      }
      const langIndex = this.multiLangImageData.findIndex(g => g.language === language);
      const imageItem = { path, imageType: null, setName, language, addCommon: true };
      let newMultiLangImageData;
      if (langIndex === -1) {
        // 分组不存在，创建新分组
        newMultiLangImageData = [...this.multiLangImageData, { language, images: [imageItem] }];
      } else {
        const targetGroup = this.multiLangImageData[langIndex];
        // 相同 path 已存在则跳过，避免重复
        if ((targetGroup.images || []).some(img => img.path === path)) return;
        newMultiLangImageData = this.multiLangImageData.map((g, idx) => {
          if (idx !== langIndex) return g;
          return {
            ...targetGroup,
            images: [...(targetGroup.images || []), imageItem]
          };
        });
      }
      // emit 给父组件，父组件现有 watch(multiLangImageData) 会自动同步到 productInfo.productImages，
      // 因此 SPU 公共图库（skuImgSpuImages）和图片信息组件都会实时看到新图片。
      this.$emit('update:multiLangImageData', newMultiLangImageData);
    },
    showViewer(index) {
      viewerApi({
        options: {
          toolbar: true,
          url: "dataSource",
          initialViewIndex: index,
          zIndex: 99999,
        },
        images: this.viewerImages,
      });
    },
    deepCopy(obj) {
      return JSON.parse(JSON.stringify(obj));
    }
  }
};
</script>

<style scoped lang="less">
.product-upload-list {
  width: 200px;
  height: 200px;
  position: relative;
  transition: transform 0.2s, opacity 0.2s, box-shadow 0.2s;
  cursor: grab;
  user-select: none;
}

.product-upload-list-cover i {
  margin: 0 6px;
}

/* SKU 多语言图片弹框样式 */
.sku-img-modal-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  border-bottom: 1px solid #e8eaec;
  padding-bottom: 10px;
  margin-bottom: 10px;

  .sku-img-ai-btn {
    margin-left: auto;
  }
}

.sku-img-tab {
  padding: 4px 12px;
  border-radius: 3px;
  font-size: 13px;
  cursor: pointer;
  color: #515a6e;
  border: 1px solid #dcdfe6;
  position: relative;
  user-select: none;
}

.sku-img-tab.active {
  background: #2d8cf0;
  color: #fff;
  border-color: #2d8cf0;
}

.sku-img-tab-count {
  display: inline-block;
  font-style: normal;
  background: #ed4014;
  color: #fff;
  font-size: 11px;
  border-radius: 8px;
  padding: 0 4px;
  margin-left: 3px;
  line-height: 1.5;
}

.sku-img-modal-sync-bar {
  display: flex;
  align-items: center;
  padding: 6px 0 10px;
  font-size: 13px;
  color: #515a6e;
  border-bottom: 1px dashed #e8eaec;
  margin-bottom: 10px;
}

.sku-img-modal-suite {
  min-height: 140px;
  padding: 10px;
  border: 1px solid #e8eaec;
  border-radius: 4px;
  margin-bottom: 12px;
}

.sku-img-set-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  flex-wrap: wrap;
  gap: 6px;
}

.sku-img-set-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
}

.sku-img-set-tag {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  font-size: 13px;
  cursor: pointer;
  color: #515a6e;
  user-select: none;
  background: #fff;
}

.sku-img-set-tag.active {
  border-color: #2d8cf0;
  color: #2d8cf0;
  background: #e8f4ff;
  font-weight: 600;
}

.sku-set-type-badge {
  display: inline-block;
  font-style: normal;
  font-size: 11px;
  padding: 0 5px;
  border-radius: 10px;
  margin-left: 5px;
  background: #19be6b;
  color: #fff;
  line-height: 1.6;
}

.sku-img-add-set-btn {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border: 1px dashed #2d8cf0;
  border-radius: 3px;
  color: #2d8cf0;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
  user-select: none;
  background: #fff;
  flex-shrink: 0;
}

.sku-img-add-set-btn:hover {
  background: #e8f4ff;
}

.sku-img-set-content {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  min-height: 108px;
  align-items: flex-start;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

/* draggable 容器 */
.draggable-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  min-height: 108px;
  max-width: 100%;
  flex: 0 0 auto;
}

/* vuedraggable 拖拽样式 */
.drag-ghost {
  opacity: 0.5;
  background: #f0f0f0;
  border: 2px dashed #2d8cf0;
  transform: scale(0.95);
}

.drag-chosen {
  opacity: 0.8;
  transform: scale(0.98);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.drag-dragging {
  opacity: 0.6;
  transform: scale(0.92);
  cursor: grabbing !important;
}

/* 图片悬停高亮效果 */
.product-upload-list:hover:not(.drag-ghost) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.product-upload-list.drag-over {
  border: 2px solid #2d8cf0;
  background-color: #e8f4ff;
  transform: scale(1.02);
  box-shadow: 0 0 0 4px rgba(45, 140, 240, 0.2);
}

.sku-img-no-set-tip {
  width: 100%;
  padding: 20px 0;
  text-align: center;
  color: #bbb;
  font-size: 13px;
}

.sku-img-set-del-bar {
  text-align: right;
  margin-top: 6px;
}

.sku-img-del-set-link {
  color: #ed4014;
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
}

.sku-img-del-set-link:hover {
  opacity: 0.75;
}

.sku-img-edit-set-link {
  color: #2d8cf0;
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
}

.sku-img-edit-set-link:hover {
  opacity: 0.75;
}

.sku-add-set-modal-body {
  padding: 4px 8px 0;
}

.sku-add-set-row {
  margin-bottom: 18px;
}

.sku-add-set-label {
  display: block;
  font-size: 13px;
  color: #17233d;
  font-weight: 600;
  margin-bottom: 8px;
}

.sku-add-set-input {
  width: 100%;
}

.sku-add-set-err {
  color: #ed4014;
  font-size: 12px;
  margin-top: 4px;
}

.sku-add-set-type-list {
  display: flex;
  gap: 16px;
}

.sku-set-type-option {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
  font-size: 13px;
  color: #515a6e;
}

.sku-set-type-radio {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 2px solid #dcdfe6;
  border-radius: 50%;
  background: #fff;
  flex-shrink: 0;
  transition: border-color 0.2s;
}

.sku-set-type-option.active .sku-set-type-radio {
  border-color: #2d8cf0;
}

.sku-set-type-radio-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2d8cf0;
}

.sku-set-type-badge-lg {
  display: inline-block;
  font-style: normal;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 10px;
  color: #fff;
  line-height: 1.6;
  font-weight: 600;
}

.sku-add-set-footer {
  text-align: right;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
  margin-top: 4px;
}

.sku-img-modal-spu {
  padding: 4px 0 8px;

  .sku-img-modal-spu-list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    min-height: 96px;
    padding: 4px;
    background: #f8f8f8;
    border-radius: 4px;

    .product-upload-list {
      .ivu-btn {
        color: #57a3f3;
        background-color: #fff;
        border-color: transparent;
      }
    }
  }
}

.sku-img-modal-spu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #17233d;
}

.sku-img-spu-lang-filter {
  display: flex;
  gap: 4px;
}

.spu-filter-tag {
  padding: 1px 7px;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  font-size: 12px;
  cursor: pointer;
  color: #515a6e;
  user-select: none;
}

.spu-filter-tag.active {
  border-color: #2d8cf0;
  color: #2d8cf0;
  background: #e8f4ff;
}
</style>